import React, { Component } from 'react';
import styled from 'styled-components';
import Input from 'components/Input';
import Button from 'components/Button';

import { Formik } from 'formik';
import * as Yup from 'yup';

const Container = styled.div`
  padding: 30px;
`;

const Select = styled.select`
  background: white;
  border-style: solid;
  border-width: 1px;
  border: none;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  border-color: #bebcbc;
  height: 44px;
  margin-top: 15px;
  padding: 10px;
  width: 100%;
  ::placeholder {
    color: #bebcbc;
    margin-left: 8px;
    font-size: 12px;
  }
`;

export default class RegionsForm extends Component {
  render() {
    const { region, submit, countriesForSelect } = this.props;
    return (
      <Formik
        enableReinitialize
        initialValues={region}
        isInitialValid={true}
        onSubmit={submit}
        validationSchema={Yup.object().shape({
          name: Yup.string().required('Required'),
        })}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          isValid,
          setFieldTouched,
          resetForm,
        }) => {
          return (
            <Container>
              <Input
                placeholder="Name"
                name="name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              />

              <Select name="country_id" value={values.country_id} onChange={handleChange}>
                <option disabled selected value>
                  Select Country
                </option>
                {countriesForSelect.map(country => (
                  <option value={`${country.id}`}>{country.name}</option>
                ))}
              </Select>
              <Button style={{ marginTop: 15 }} disabled={!isValid} onClick={() => submit(values)}>
                Save
              </Button>
            </Container>
          );
        }}
      </Formik>
    );
  }
}
